import { lazy, Suspense, useState } from 'react';

import { usePaymentInProgress } from '../billing';

const CheckoutResult = lazy(() =>
  import('./CheckoutResult').then((m) => ({ default: m.CheckoutResult })),
);

/**
 * Loads E-15 to E-17 only when they can show. Two ways in: coming back from Stripe (a full page load
 * with `?checkout`), and the page that is paying right now, which has no parameter yet. Both are
 * latched: the result cleans the parameter, and the modal closes, while E-16 is still up.
 */
export function CheckoutHost() {
  const [needed, setNeeded] = useState(() => {
    const search = new URLSearchParams(window.location.search);
    return search.has('checkout') || search.get('portal') === 'done';
  });
  const paying = usePaymentInProgress();
  if (paying && !needed) setNeeded(true);
  if (!needed && !paying) return null;
  return (
    <Suspense fallback={null}>
      <CheckoutResult />
    </Suspense>
  );
}
